import { IxPrimaryTab } from './IxPrimaryTab.js';

window.customElements.define('ix-primary-tab', IxPrimaryTab);
